import { DEFAULT_MINUTES_FORMAT } from '@constants';
import { useSectorMark } from '@hooks/useSectorMarkHook';
import { NOTICE_STATUS } from '@views/pages/AnnouncementList/announcement';
import { validate } from 'uuid';

const maxLength = 200; // input框最大长度
const amountMaxLength = 9; // 数字框最大长度
const amountMax = 999999999; // 数字框最大值

export enum PROJECT_MODE {
  CREATE = 'CREATE',
  EDIT = 'EDIT'
}

export const subjectMatterErrorText =
  '请填写整包中标金额或整包中标金额备注中一项或多项';

const noticeLinkValidator = (rule: any, value: string) => {
  if (!value) {
    return Promise.resolve();
  }
  if (/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g.test(value.trim())) {
    return Promise.reject('只能输入英文和符号');
  }

  return Promise.resolve();
};

// 项目状态:1:待admin处理(软状态,数据初始化默认状态,只有admin分配sector后,sector才能看到),10:待招标,11:招标中,12:结束招标,0:已删除
export const projectStatusMap = {
  waittingForTender: '10', // 待招标
  duringTender: '11', // 招标中
  endTender: '12', // 结束招标
  deleted: '0',
  replenishOppid: '31' // 补充oppid
};

export const subjectMatterBrandStatusMap = {
  DomesticBrand: '8',
  Other: '9'
};

export const subjectMatterBrandKeyArr = [
  subjectMatterBrandStatusMap.DomesticBrand,
  subjectMatterBrandStatusMap.Other
];

// 新建公告
export const use_NOTICE_FORM_LIST = () => {
  const sectorMark = useSectorMark();
  return [
    {
      label: '项目状态',
      required: true,
      type: 'select',
      name: 'subjectMatterProjectStatus',
      optionsListKey: 'projectStatus'
    },
    {
      label: '信息标题',
      required: false,
      type: 'input',
      name: 'infoTitle'
    },
    {
      label: '项目名称',
      required: true,
      type: 'input',
      name: 'projectName'
    },
    {
      label: '客户单位',
      required: true,
      type: 'input',
      name: 'customerCompany',
      maxLength
      // showCount: true
    },
    {
      label: '客户单位联系人',
      required: false,
      type: 'input',
      name: 'tenderOrgContacts',
      maxLength
    },
    {
      label: '客户单位联系方式',
      required: false,
      type: 'input',
      name: 'tenderOrgContactsMobile',
      maxLength
    },
    {
      label: sectorMark,
      required: true,
      type: 'select',
      name: 'sectorType',
      optionsListKey: 'sector'
    },
    {
      label: '客户单位类型',
      required: true,
      type: 'cascader',
      name: 'customerCompanyType'
      // optionsListKey: 'sector'
    },
    {
      label: '行业',
      required: false,
      type: 'select',
      name: 'industryKey'
    },
    {
      label: '应用方向',
      required: false,
      type: 'cascader',
      name: 'applicationDirectionKey'
      // fieldNames:DIC_FIELD_NAMES
    },
    {
      label: '招标预算（万元）',
      required: false,
      type: 'amount',
      name: 'tenderBudget',
      maxLength: amountMaxLength,
      max: amountMax
    },
    // {
    //   label: '预计采购时间',
    //   required: false,
    //   type: 'time',
    //   name: 'estimatedPurchaseTime'
    // },
    {
      label: '发布时间',
      required: false,
      type: 'time',
      name: 'publishTime',
      format: DEFAULT_MINUTES_FORMAT,
      showTime: true
    },
    {
      label: '开标时间',
      required: true,
      type: 'time',
      name: 'tenderOpenTime'
      // format: DEFAULT_DATE_FORMAT,
      // showTime: true
    },
    {
      label: '整包中标金额（万元）',
      required: false,
      type: 'amount',
      name: 'successfulPrice',
      disabled: true,
      maxLength: amountMaxLength,
      max: amountMax
    },
    {
      label: '整包中标金额备注',
      required: false,
      type: 'input',
      name: 'successfulPriceRemark',
      maxLength
    },
    {
      label: '省市',
      required: true,
      type: 'cascader',
      name: 'provinceAndCity',
      placeholder: '请选择省市'
    },
    {
      label: '招标机构',
      required: false,
      type: 'input',
      name: 'tenderDealer',
      maxLength
    },

    {
      label: '公告链接',
      required: true,
      type: 'input',
      name: 'noticeLink',
      maxLength,
      rules: [
        { required: true },
        { validator: noticeLinkValidator },
        { whitespace: true }
      ]
    }
  ];
};

// 新建公告中的标的物
export const TARGET_STUFF = [
  {
    label: '产品分类',
    required: true,
    type: 'select',
    name: 'productLineKey',
    optionsListKey: 'productLine'
  },
  {
    label: '标的物',
    required: true,
    type: 'input',
    name: 'subjectMatterName',
    maxLength
  },
  {
    label: '标的物品牌',
    required: false,
    type: 'select',
    name: 'subjectMatterBrandKey',
    optionsListKey: 'subjectMatterBrand'
  },
  {
    label: ' ',
    required: false,
    type: 'input',
    name: 'subjectMatterBrand',
    placeholder: '填写制造商',
    maxLength
  },
  // {
  //   label: '制造商',
  //   required: false,
  //   type: 'input',
  //   name: 'subjectMatterBrand',
  //   maxLength
  // },
  {
    label: '标的物型号',
    required: false,
    type: 'input',
    name: 'subjectMatterModel',
    maxLength
  },
  {
    label: '项目是否要求国产',
    required: false,
    type: 'checkbox',
    name: 'importType',
    optionsListKey: 'importType',
    className: 'client_import_type'
  },
  {
    label: '标的物中标单价(万元)',
    required: false,
    type: 'amount',
    disabled: true,
    name: 'subjectMatterPrice',
    maxLength: amountMaxLength,
    max: amountMax
  },
  {
    label: '台数',
    required: false,
    type: 'step',
    name: 'subjectMatterNumber',
    max: 1000,
    min: 1
  },
  {
    label: '标的物中标总价(万元)',
    required: false,
    type: 'amount',
    name: 'totalAmount',
    maxLength: amountMaxLength,
    max: amountMax
  },
  // {
  //   label: '预计采购时间',
  //   required: false,
  //   type: 'time',
  //   name: 'estimatedPurchaseTime'
  // },
  {
    label: '中标商',
    required: false,
    type: 'input',
    name: 'successfulCompany',
    maxLength
  }
  // {
  //   label: '中标金额(如未填写，请备注说明)',
  //   required: false,
  //   type: 'amount',
  //   name: 'successfulPrice',
  //   maxLength: amountMaxLength,
  //   max: amountMax
  // },
  // {
  //   label: '中标金额备注',
  //   required: false,
  //   type: 'input',
  //   name: 'successfulPriceRemark',
  //   maxLength
  // },
  // {
  //   label: '主要配置',
  //   required: false,
  //   type: 'input',
  //   name: 'majorDispositions',
  //   maxLength
  // }
];

export const getTotalAmountLimitByCurrency = (
  currency?: string | number
): number => {
  const limitMap: Record<string, number> = {
    '1': 1000, // CNY
    '2': Number((1000 / 7).toFixed(2)), // USD
    '3': Number((1000 / 8).toFixed(2)) // EUR
  };

  return limitMap[String(currency)] ?? 1000;
};

export const getTotalAmountWarningMessage = (
  currency?: string | number
): string => {
  const limit = getTotalAmountLimitByCurrency(currency);
  return `金额超过${limit}万，请确认金额是否准确`;
};

export const isTotalAmountOverLimit = (
  value?: string | number,
  currency?: string | number
): boolean => {
  if (value === undefined || value === null || value === '') {
    return false;
  }

  return Number(value) > getTotalAmountLimitByCurrency(currency);
};

export enum ANNOUNCEMENT_COLLAPSE_TYPE {
  NOTICE = 'NOTICE',
  TARGET_STUFF = 'TARGET_STUFF'
}

export const tagClassMap: any = {
  [NOTICE_STATUS.Admin]: '',
  [NOTICE_STATUS.Sector]: 'tag_2',
  [NOTICE_STATUS.Sales]: 'tag_3',
  [NOTICE_STATUS.Confirmed]: 'tag_4',
  [NOTICE_STATUS.Uncorrelated]: 'tag_5',
  [NOTICE_STATUS.Repetition]: 'tag_6'
};

export const COMMON_BOOLEAN_MAP = {
  yes: '0',
  no: '1'
};

export const COMMON_BOOLEAN_LABEL_MAP = {
  [COMMON_BOOLEAN_MAP.yes]: '是',
  [COMMON_BOOLEAN_MAP.no]: '否'
};

export const commonSelectList = [
  {
    label: COMMON_BOOLEAN_LABEL_MAP[COMMON_BOOLEAN_MAP.yes],
    value: COMMON_BOOLEAN_MAP.yes
  },
  {
    label: COMMON_BOOLEAN_LABEL_MAP[COMMON_BOOLEAN_MAP.no],
    value: COMMON_BOOLEAN_MAP.no
  }
];

export const COMMON_BOOLEAN_MAP_2 = {
  yes: '1',
  no: '0'
};

export const COMMON_BOOLEAN_LABEL_MAP_2 = {
  [COMMON_BOOLEAN_MAP_2.yes]: '是',
  [COMMON_BOOLEAN_MAP_2.no]: '否'
};

export const commonSelectList_2 = [
  {
    label: COMMON_BOOLEAN_LABEL_MAP_2[COMMON_BOOLEAN_MAP_2.yes],
    value: COMMON_BOOLEAN_MAP_2.yes
  },
  {
    label: COMMON_BOOLEAN_LABEL_MAP_2[COMMON_BOOLEAN_MAP_2.no],
    value: COMMON_BOOLEAN_MAP_2.no
  }
];

export const orderSelectList = [
  {
    label: '赢单',
    value: '1'
  },
  {
    label: '输单',
    value: '2'
  }
];

// 待招标
export const waittingForTenderArr = [
  {
    label: '是否已知项目',
    required: true,
    type: 'checkbox',
    name: 'coverageStatus',
    options: commonSelectList,
    fieldNames: {}
  },
  {
    label: '产品线',
    required: true,
    type: 'cascader',
    name: 'projectProductLineKey',
    optionsListKey: 'projectProductLine',
    changeOnSelect: false,
    // fieldNames:DIC_FIELD_NAMES，
    optional: {
      text: 'AI判断结果：',
      valueKey: 'productLineAi'
    }
  },
  {
    label: '品牌',
    required: false,
    type: 'cascader',
    name: 'projectBrandKey',
    optionsListKey: 'projectBrand',
    changeOnSelect: false,
    optional: {
      text: 'AI判断结果：',
      valueKey: 'brandAi'
    }
  },
  {
    label: '其他品牌',
    required: false,
    type: 'input',
    name: 'projectBrandOtherKey',
    maxLength
  },
  {
    label: '型号',
    required: false,
    type: 'cascader',
    name: 'projectModelKey',
    optionsListKey: 'projectModel',
    changeOnSelect: false,
    optional: {
      text: 'AI判断结果：',
      valueKey: 'modelAi'
    }
  },
  {
    label: '其他型号',
    required: false,
    type: 'input',
    name: 'projectModelOtherKey',
    maxLength
  },
  {
    label: 'A/B/C Class',
    type: 'select',
    required: false,
    name: 'projectClassKey',
    fieldNames: { label: 'label', value: 'value' },
    placeholder: '请选择A/B/C Class',
    optional: {
      text: 'AI判断结果：',
      valueKey: 'classTypeValueAi'
    }
  },
  {
    label: '主要配置',
    required: false,
    type: 'input',
    name: 'mainConfig',
    maxLength
  },
  {
    label: '选择负责的销售',
    required: true,
    type: 'select',
    name: 'subjectMatterProjectSaleId',
    fieldNames: { label: 'realName', value: 'userId' },
    placeholder: '选择负责的销售'
  },
  {
    label: '是否有Opportunity ID',
    required: true,
    type: 'checkbox',
    name: 'opportunityStatus',
    options: commonSelectList,
    fieldNames: {}
  },
  {
    label: '是否创建Leads',
    required: true,
    type: 'checkbox',
    name: 'createLeads',
    options: commonSelectList_2,
    fieldNames: {}
  },
  {
    type: 'custom',
    name: 'OppIDArr'
  },
  {
    label: '是否为大规模设备更新',
    required: false,
    type: 'checkbox',
    name: 'lerStatus',
    options: commonSelectList,
    fieldNames: {}
  },
  {
    label: '线下表格',
    type: 'select',
    required: false,
    name: 'offlineFormKey',
    optionsListKey: 'offlineForm'
  },
  {
    label: '表格ID',
    required: true,
    type: 'input',
    name: 'offlineFormId',
    maxLength
  },

  {
    label: '请选择负责的经销商',
    required: false,
    type: 'select',
    name: 'corpId',
    fieldNames: {},
    placeholder: '请选择负责的经销商'
  },
  {
    label: '选择负责的经销商销售',
    required: true,
    type: 'select',
    name: 'dealerUserId',
    fieldNames: {},
    placeholder: '选择负责的经销商销售'
  }
];

// 结束招标
export const endTenderArr = [
  {
    label: '是否已知项目',
    required: true,
    type: 'checkbox',
    name: 'coverageStatus',
    options: commonSelectList,
    fieldNames: {}
  },

  {
    label: '产品线',
    required: true,
    type: 'cascader',
    name: 'projectProductLineKey',
    optionsListKey: 'projectProductLine',
    changeOnSelect: false
    // fieldNames:DIC_FIELD_NAMES
  },
  {
    label: '品牌',
    required: true,
    type: 'cascader',
    name: 'projectBrandKey',
    optionsListKey: 'projectBrand',
    changeOnSelect: false
  },
  {
    label: '其他品牌',
    required: true,
    type: 'input',
    name: 'projectBrandOtherKey',
    maxLength
  },
  {
    label: '型号',
    required: true,
    type: 'cascader',
    name: 'projectModelKey',
    optionsListKey: 'projectModel',
    changeOnSelect: false
  },
  {
    label: '其他型号',
    required: false,
    type: 'input',
    name: 'projectModelOtherKey',
    maxLength
  },
  {
    label: 'A/B/C Class',
    type: 'select',
    required: true,
    name: 'projectClassKey',
    fieldNames: { label: 'label', value: 'value' },
    placeholder: '请选择A/B/C Class'
  },
  {
    label: '主要配置',
    required: false,
    type: 'input',
    name: 'mainConfig',
    maxLength
  },

  {
    label: '是否有Opportunity ID',
    required: true,
    type: 'checkbox',
    name: 'opportunityStatus',
    options: commonSelectList,
    fieldNames: {}
  },
  {
    label: '是否创建Leads',
    required: true,
    type: 'checkbox',
    name: 'createLeads',
    options: commonSelectList_2,
    fieldNames: {}
  },
  {
    type: 'custom',
    name: 'OppIDArr'
  },
  {
    label: '是否为大规模设备更新',
    required: true,
    type: 'checkbox',
    name: 'lerStatus',
    options: commonSelectList,
    fieldNames: {}
  },
  {
    label: '线下表格',
    type: 'select',
    required: false,
    name: 'offlineFormKey',
    optionsListKey: 'offlineForm'
  },
  {
    label: '表格ID',
    required: true,
    type: 'input',
    name: 'offlineFormId',
    maxLength
  },
  {
    label: '是否参与招投标',
    type: 'checkbox',
    name: 'attendTenderStatus',
    optionsListKey: 'coverageStatus',
    required: true
  },
  {
    label: '是否有Pros招投标号？',
    type: 'checkbox',
    name: 'prosNumStatus',
    optionsListKey: 'applyProsStatus',
    required: true
  },
  {
    label: '赢单/输单',
    type: 'checkbox',
    name: 'loseWinStatus',
    options: orderSelectList,
    required: true,
    fieldNames: {}
  },
  {
    label: '选择赢单原因',
    type: 'select',
    required: true,
    name: 'coreLoseReasonStatus',
    optionsListKey: 'coreWinReason'
  },
  {
    label: '是否为老客户',
    type: 'checkbox',
    required: true,
    name: 'oldCustomerStatus',
    options: commonSelectList,
    fieldNames: {}
  },
  {
    label: '老客户机型',
    required: true,
    type: 'input',
    name: 'oldCustomerModel',
    maxLength
  },
  {
    label: '选择负责的销售',
    required: true,
    type: 'select',
    name: 'subjectMatterProjectSaleId',
    fieldNames: { label: 'realName', value: 'userId' },
    placeholder: '选择负责的销售'
  },
  {
    label: '请选择负责的经销商',
    required: false,
    type: 'select',
    name: 'corpId',
    fieldNames: {},
    placeholder: '请选择负责的经销商'
  },
  {
    label: '选择负责的经销商销售',
    required: true,
    type: 'select',
    name: 'dealerUserId',
    fieldNames: {},
    placeholder: '选择负责的经销商销售'
  }
];

// 待招标
export const waittingForTenderRequired: any = {
  industryKey: {
    required: false
  },
  // tenderOpenTime: {
  //   required: false
  // },
  subjectMatterModel: {
    required: false
  },
  subjectMatterBrand: {
    required: false
  },
  subjectMatterBrandKey: {
    required: false
  },
  tenderOrgContacts: {
    required: false
  },
  tenderOrgContactsMobile: {
    required: false
  }
};
// 招标中
export const duringTenderRequired: any = {
  industryKey: {
    required: false
  },
  // tenderOpenTime: {
  //   required: false
  // },
  subjectMatterModel: {
    required: false
  },
  subjectMatterBrand: {
    required: false
  },
  subjectMatterBrandKey: {
    required: false
  },
  tenderOrgContacts: {
    required: true
  },
  tenderOrgContactsMobile: {
    required: true
  },
  projectBrandKey: {
    required: true
  },
  projectModelKey: {
    required: true
  },
  projectClassKey: {
    required: true
  },
  projectBrandOtherKey: {
    required: true
  }
};
// 结束招标
export const endTenderRequired: any = {
  industryKey: {
    required: true
  },
  // tenderOpenTime: {
  //   required: true
  // },
  subjectMatterModel: {
    required: false
  },
  subjectMatterBrand: {
    required: true
  },
  subjectMatterBrandKey: {
    required: false
  },
  tenderOrgContacts: {
    required: true
  },
  tenderOrgContactsMobile: {
    required: true
  }
};

export const DEFAULT_PROJECT_FORM_DATA = {
  coverageStatus: null,
  opportunityStatus: null,
  lerStatus: null,
  // subjectMatterProjectSaleId: null,
  // subjectMatterProjectSaleName: null,
  attendTenderStatus: null,
  prosNumStatus: null,
  loseWinStatus: null,
  coreLoseReasonStatus: null,
  oldCustomerStatus: null,
  oldCustomerModel: null,
  projectProductLineKey: null,
  projectProductLineValue: null,
  oppId: null
};

// // 查询OppID的表单项
// export const SEARCH_OPPID_ITEMS = [
//  {
//     label: ' ',
//     required: false,
//     type: 'input.search',
//     name: 'subjectMatterBrand',
//     placeholder: '请输入企业名称搜索',
//     maxLength,
//   },
// ];
